/* global MS_ANALYTICS_URL, LIGHTHOUSE_COOKIE_ID, VERSION */

import 'core-js/stable/promise';
import 'core-js/stable/object/assign';
import IdService from './id_service';
import Lighthouse from './lighthouse';
import MsAnalytics from './ms_analytics';
import Tracker from './tracker';
import initializeSegment from './segment';
import initializeBluekai, * as BluekaiAnalytics from './bluekai';

const initialize = ({ data }) => {
  initializeSegment();
  initializeBluekai({ data });

  return window.analytics;
};

const create = ({ data, isSpa }) => {
  const segmentAnalytics = window.analytics;
  const lighthouseInstance = new Lighthouse(LIGHTHOUSE_COOKIE_ID);
  const msAnalytics = new MsAnalytics(MS_ANALYTICS_URL, VERSION);

  const tracker = new Tracker({
    analytics: segmentAnalytics,
    bluekaiAnalytics: BluekaiAnalytics,
    msAnalytics,
    lighthouse: lighthouseInstance,
  });

  tracker.checkForExperimentCookie();

  if (!isSpa) {
    tracker.pageView(data);
  }

  tracker.executeQueuedEvents(window.tracker);
  return tracker;
};

// Only initialise if config is found on the page, also means this is non-breaking
// for services using the on page config
const trackerConfig = window.trackerConfig || {};
initialize(trackerConfig).ready(() => {
  window.analytics._user.anonymousId(IdService.getId()); // set anonymous id
  window.tracker = create(trackerConfig);
});

export { initialize, create };
